
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsOptional, IsString, IsUUID } from "class-validator";

export class SubjectDto {
  @ApiPropertyOptional({ description: 'ID de la matière', type: 'string' })
  @IsOptional()
  @IsUUID()
  id?: string;

  @ApiPropertyOptional({ description: 'Code de la matière', type: 'string' })
  @IsOptional()
  @IsString()
  code?: string;

  @ApiPropertyOptional({ description: 'Label de la matière', type: 'string' })
  @IsOptional()
  @IsString()
  label?: string;

  @ApiPropertyOptional({ description: 'Couleur de la matière', type: 'string' })
  @IsOptional()
  @IsString()
  color?: string;
}
